// JavaScript Document
"use strict";

var PACCO = PACCO || {};

/**
 * common
 */
PACCO.common = (function($) {
	/* alias */
	const Tw = gsap || null;
	const P0 = Power0 || null ;
	const P1 = Power1 || null ;
	const P2 = Power2 || null ;
	const P3 = Power3 || null ;
	const P4 = Power4 || null ;
	const Si = Sine || null ;
	const Ci = Circ || null ;
	const Ex = Expo || null ;
	const Ba = Back || null ;
	const Bo = Bounce || null ;
	const El = Elastic || null ;

	/* private const */
	const $WINDOW = $(window), $HEADER = $('header'),
	
	TOUCH = 'ontouchstart' in window || navigator.msPointerEnabled;

	/* private let */
	let _w, _h, _hh, _st, _jsp;

	let onResize = function() {
		_w = window.innerWidth;
		_h = window.innerHeight;

		_hh = $HEADER.outerHeight(true);

		if(_jsp) {
			_jsp.reinitialise({animateScroll:true});
		}
	};

	var onScroll = function() {
		_st = $WINDOW.scrollTop();

		let $e;
		$('.parallax').each(function(i, e) {
			$e = $(e);
			let diff = Math.max(0, Math.min(1, ($e.offset().top - _st + $e.height()) / (_h + $e.height())));
			$e.css('background-position', 'center ' + (diff * 100) + '%');
		});
	};

	let _self = {
		init: function() {
			$WINDOW.on('scroll', onScroll);
			$WINDOW.on('resize load', onResize).trigger('resize');

			var links = document.links;
			for (let i = 0, linksLength = links.length ; i < linksLength ; i++) {
			  if (links[i].hostname !== window.location.hostname) {
			    links[i].target = '_blank';
			    links[i].rel = 'noreferrer noopener';
			  }
			}

			/* タイトル文字を<span>に分割 */
			$('.ani_ttl').each(function (i, e) {
				var $e = $(e), str = $e.html(), char = [];
				str = str.replace(/<br>/g, '^');
				str = str.replace(/<br class="sp">/g, '~');
				for (var j = 0; j < str.length; j++) {
					var c = str.charAt(j);
					if (c === '^') {
						char.push('<br>');
					} else if (c === '~') {
						char.push('<br class="sp">');
					} else if(c === ' ') {
						char.push('^');
					} else {
						char.push('<span class="char">' + c + '</span>');
					}
				}
				var words = char.join('').split('^').join('</span><span class="char">&nbsp;</span><span class="word">');
				$e.html('<span class="word">' + words.replace(/<br>/g, '</span><br><span class="word">').replace(/<br class="pc">/g, '</span><br class="pc"><span class="word">').replace(/<br class="sp">/g, '</span><br class="sp"><span class="word">') + '</span>');

				$e.addClass('splited');
			}).css('opacity', 1);

			$('#btn_menu').on('click', function(){
				_self.openMenu(!$HEADER.hasClass('open'));
			});

			$('#cover').on('click', function(){
				_self.openMenu(false);
			});

			$('.btn_modal').on('click', function(){
				$('#modal .body').hide();
				$($(this).data('target')).show();
				Tw.fromTo($('#modal'), 0.3, {opacity:0}, {opacity:1, display: 'block', ease:P1.easeOut});
				return false;
			});
			$('.bg, .btn_close','#modal').on('click', function(){
				Tw.to($('#modal'), 0.15, {opacity:0, display: 'none', ease:P1.easeOut});
			});

			if(TOUCH) {
				 $('#product_list .slider .slider_inner').addClass('touch');
			} else {
				_jsp = $('#product_list .slider .slider_inner').jScrollPane({animateScroll:true}).data('jsp');
				$('#product_list .slider .btn_prev').on('click', function(){
					let itemW = $('#product_list .slider .item').outerWidth(true);
					let pos = Math.floor(_jsp.getContentPositionX() / itemW) - 1;
					_jsp.scrollToX(itemW * pos);
				});
				$('#product_list .slider .btn_next').on('click', function(){
					let itemW = $('#product_list .slider .item').outerWidth(true);
					let pos = Math.floor(_jsp.getContentPositionX() / itemW) + 1;
					_jsp.scrollToX(itemW * pos);
				});
			}
		},
		openMenu:function(bool){
			if(bool) {
				$HEADER.addClass('open');
				Tw.to($('#btn_menu span:eq(0)'), 0.15, {y:0, ease:P1.easeOut});
				Tw.to($('#btn_menu span:eq(0)'), 0.15, {delay:0.15, rotation:'45deg', ease:P1.easeIn});
				Tw.to($('#btn_menu span:eq(1)'), 0.15, {delay:0.15, opacity:0, ease:P1.easeIn});
				Tw.to($('#btn_menu span:eq(2)'), 0.15, {y:0, ease:P1.easeOut});
				Tw.to($('#btn_menu span:eq(2)'), 0.15, {delay:0.15, rotation:'-45deg', ease:P1.easeIn});
			} else {
				$HEADER.removeClass('open');
				Tw.to($('#btn_menu span:eq(0)'), 0.15, {rotation:0, ease:P1.easeOut});
				Tw.to($('#btn_menu span:eq(0)'), 0.15, {delay:0.15, y:-8, ease:P1.easeIn});
				Tw.to($('#btn_menu span:eq(1)'), 0.15, {rotation:0, opacity:1, ease:P1.easeOut});
				Tw.to($('#btn_menu span:eq(2)'), 0.15, {rotation:0, ease:P1.easeOut});
				Tw.to($('#btn_menu span:eq(2)'), 0.15, {delay:0.15, y:8, ease:P1.easeOut});
			}
		},
		smoothScroll:function(pos) {
			$('html, body').stop().animate({scrollTop:(_state == SP) ? pos - 65 : pos}, {duration:500, queue:false});
		}
	};
		
	return _self;
}(jQuery));
jQuery(PACCO.common.init);